"use client";

import Image from "next/image";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";

type Project = {
  image: string;
  alt: string;
  place: string;
  kind: string;
  line: string;
};

type ProjectCarouselProps = {
  projects: readonly Project[];
};

const AUTO_ADVANCE_DELAY = 10000;

export function ProjectCarousel({ projects }: ProjectCarouselProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (projects.length < 2) return;

    const timer = window.setInterval(() => {
      setActiveIndex((index) => (index + 1) % projects.length);
    }, AUTO_ADVANCE_DELAY);

    return () => window.clearInterval(timer);
  }, [projects.length]);

  if (projects.length === 0) return null;

  const activeProject = projects[activeIndex];
  const previous = () => setActiveIndex((index) => (index - 1 + projects.length) % projects.length);
  const next = () => setActiveIndex((index) => (index + 1) % projects.length);

  return (
    <div className="nh-project-carousel" aria-roledescription="carrousel" aria-label="Gebouwde projecten">
      <div className="nh-project-carousel-image">
        <Image
          key={activeProject.image}
          src={activeProject.image}
          alt={activeProject.alt}
          fill
          sizes="(max-width: 760px) 100vw, 80vw"
        />
      </div>

      <div className="nh-project-carousel-copy">
        <span>{activeProject.place} · {activeProject.kind}</span>
        <h3>{activeProject.line}</h3>
      </div>

      <div className="nh-project-carousel-controls">
        <p><strong>{String(activeIndex + 1).padStart(2, "0")}</strong> / {String(projects.length).padStart(2, "0")}</p>
        <div>
          <button type="button" onClick={previous} aria-label="Vorig project">
            <ChevronLeft aria-hidden="true" size={20} strokeWidth={1.8} />
          </button>
          <button type="button" onClick={next} aria-label="Volgend project">
            <ChevronRight aria-hidden="true" size={20} strokeWidth={1.8} />
          </button>
        </div>
      </div>

    </div>
  );
}
